
import { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { StockData } from '../data/sampleData';

interface BacktestResultsTableProps {
  stockData: StockData;
}

const BacktestResultsTable = ({ stockData }: BacktestResultsTableProps) => {
  const [results, setResults] = useState<any[]>([]);
  
  useEffect(() => {
    // Generate sample backtest data
    const sampleData = [];
    const today = new Date();
    
    for (let i = 0; i < 10; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() - (10 - i));
      
      const actual = 5000 + Math.random() * 200;
      const predicted = actual * (1 + (Math.random() * 0.02 - 0.01));
      const difference = ((predicted - actual) / actual) * 100;
      const accuracy = 100 - Math.abs(difference);
      
      sampleData.push({
        date: date.toISOString().split('T')[0],
        actual: actual.toFixed(2),
        predicted: predicted.toFixed(2),
        difference: difference >= 0 ? `+${difference.toFixed(2)}%` : `${difference.toFixed(2)}%`,
        accuracy: `${accuracy.toFixed(2)}%`,
        color: Math.abs(difference) < 0.5 ? "text-green-600" : Math.abs(difference) < 1 ? "text-yellow-600" : "text-red-600"
      });
    }
    
    setResults(sampleData);
  }, [stockData]);
  
  return (
    <div className="w-full bg-card border rounded-xl overflow-hidden p-6">
      <h3 className="text-xl font-semibold mb-4">Backtest Results</h3>
      
      <div className="rounded-md border">
        <Table>
          <TableCaption>Recent backtest results for {stockData.symbol}</TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Actual</TableHead>
              <TableHead>Predicted</TableHead>
              <TableHead>Difference</TableHead>
              <TableHead>Accuracy</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {results.map((result, index) => (
              <TableRow key={index}>
                <TableCell>{new Date(result.date).toLocaleDateString()}</TableCell>
                <TableCell>${result.actual}</TableCell>
                <TableCell>${result.predicted}</TableCell>
                <TableCell className={result.color}>{result.difference}</TableCell>
                <TableCell>{result.accuracy}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default BacktestResultsTable;
